import React, { useEffect, useRef } from 'react'

import {ReactComponent as IconArrowDown} from '../../../assets/icons/ic-arrow-down.svg'
import {ReactComponent as IconArrowUp} from '../../../assets/icons/ic-arrow-up.svg'
import {ReactComponent as IconCheckBlue} from '../../../assets/icons/ic-check-blue.svg'

const Dropdown = ({ type, isShow, isUpSide, value, valueArr, handleClick, handleValueClick }) => {
    const openRef = useRef(null)
    const dropdownRef = useRef(null)

    const handleClickOutside = (event) => {
        if (openRef.current && openRef.current.contains(event.target)) {
            return
        }
        if(dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            handleClick(false)
        }
    }

    useEffect(() => {
        window.addEventListener('mousedown', handleClickOutside);
    }, [])

    return (
        <div ref={openRef} className="relative flex items-center mr-2 text-white cursor-pointer" onClick={() => { handleClick() }} style={{ padding: '7px 8px', width: 256, height: 32, borderRadius: 6, border: '1px solid #5E5E5E', background: 'linear-gradient(180deg, #5E5E5E 0%, #383838 100%)'}}>
            <span className="" style={{ fontWeight: 300 }}>{ value.label }</span>
            {
                isShow ? <IconArrowUp className="ml-auto"/> : <IconArrowDown className="ml-auto"/>
            }
            {
                isShow &&
                <div ref={dropdownRef} className="absolute bg-[#1F1F1F] rounded-[6px]" style={{ width: 256, top: isUpSide ? (valueArr.length * -32 - 23) : 32, left: 0, zIndex: 9999, padding: '8px 0', border: '1px solid #5E5E5E', boxShadow: '0px 12px 12px 0px #00000099' }}>
                    {
                        valueArr.map((item, idx) => {
                            return (
                                <div 
                                    onClick={() => { handleValueClick(item) }}
                                    className="flex items-center px-2 room-list-item"
                                    key={`dropdown-list-item-${type}-${idx}`}
                                    style={{ height: 32, color: item.label === value.label ? '#3182F7' : '', fontWeight: 300 }}>
                                    { item.label }
                                    {
                                        item.label === value.label &&
                                        <IconCheckBlue className="ml-auto"/>
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            }
        </div>
    )
}

export default Dropdown